export default "__VITE_ASSET__JVxRC7iv__"